import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Sitecore, SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { CustomLoadingIndicatorService, ILoadingIndicatorHandler, LOADING_INDICATOR } from '@frontend/sports/loading-indicator-feature';
import { BetslipState } from 'packages/sports/common/betslip/core/betslip-state';
import { BetslipIntegrationService } from 'packages/sports/common/betslip/integration/betslip-integration.service';
import { distinctUntilChanged } from 'rxjs';

const loaderToken = 'EDIT_BET_SAVING';

@Component({
    selector: 'ms-my-bets-editing-overlay',
    templateUrl: 'my-bets-editing-overlay.html',
    providers: [{ provide: LOADING_INDICATOR, useValue: loaderToken }],
})
export class MyBetsEditingOverlayComponent implements OnInit {
    isBetPlacingInProgress = false;

    private loadingIndicator: ILoadingIndicatorHandler | null;
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        public sitecore: Sitecore,
        public sitecoreMyBets: SitecoreMyBetsConfig,
        private loadingIndicatorService: CustomLoadingIndicatorService,
        private betslipIntegrationService: BetslipIntegrationService,
    ) {}

    ngOnInit(): void {
        this.betslipIntegrationService
            .betslipState$()
            .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
            .subscribe((state) => {
                this.isBetPlacingInProgress = state === BetslipState.Placing;
                if (this.isBetPlacingInProgress) {
                    this.loadingIndicator = this.loadingIndicatorService.start(loaderToken);
                } else if (this.loadingIndicator) {
                    this.loadingIndicator.done();
                }
            });
    }

    onCancelClick(): void {
        this.betslipIntegrationService.requestExitEditBet();
    }
}
